import script from "./ThemsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemsView.vue?vue&type=script&setup=true&lang=js"

import "./ThemsView.vue?vue&type=style&index=0&id=e884d870&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e884d870"]])

export default __exports__